import { render, staticRenderFns } from "./ObjectifCard.vue?vue&type=template&id=1ed1a58d"
import script from "./ObjectifCard.vue?vue&type=script&lang=js"
export * from "./ObjectifCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports